import React, { useEffect, useRef, useState, useMemo } from "react";
import ReactDOM from "react-dom";
import { axios_instance } from "../../../api/axios_instance";
import { modalEventListener } from "../../../utils/ModalEventListener";
import { isDeleteButtonDisabled } from "../../../utils/helperFunctions";
import { useSelector } from "react-redux";
import { convertToUTCFormat, formatAmount } from "../../../utils/format";
import { format } from "date-fns";
import ConfirmBox from "../../../layouts/ConfirmBox";
import ModalWrapper from "../../../layouts/ModalWrapper";

const BankPaymentDetailsModal = ({
  closeBankDetailsModal,
  BankSummary,
  lead_id,
  dis_id,
  sub_stage,
  current_balance,
  deletePayment,
  showBankDetailsModal,
}) => {
  const [state, setState] = useState({
    showConfirmBox: false,
    callFunction: () => {},
  });
  const ref = useRef();
  useEffect(() => {
    return modalEventListener(ref, closeBankDetailsModal);
  }, [closeBankDetailsModal]);

  const deleteBankPayment = async (
    bank_payment_amount,
    bank_payment_id,
    current_balance
  ) => {
    try {
      await axios_instance({
        url: "/dts/deleteBankPayment",
        method: "DELETE",
        data: {
          lead_id,
          bank_payment_amount,
          bank_payment_id,
          current_balance,
        },
      });
      deletePayment(bank_payment_id, bank_payment_amount);
    } catch (error) {}
  };

  const openConfirmBox = (callFunction) => {
    setState((prevState) => ({
      ...prevState,
      showConfirmBox: true,
      callFunction,
    }));
  };

  const user = useSelector((state) => state.user);
  const isBtnDis = isDeleteButtonDisabled(user);
  const paymentLabels = useMemo(() => {
    const labels = {};
    let counter = 1;

    [...BankSummary] // do NOT mutate the original
      .reverse()
      .forEach((pmt) => {
        const key = pmt.bank_payment_id;
        if (pmt.misc_receipt === 0) {
          if (!labels[key]) {
            labels[key] = `Payment ${counter}`;
            counter++;
          }
        } else {
          labels[key] = "Misc. Receipt";
        }
      });
    return labels;
  }, [BankSummary]);

  return ReactDOM.createPortal(
    <ModalWrapper show={showBankDetailsModal} onClose={closeBankDetailsModal}>
      {state.showConfirmBox && (
        <ConfirmBox
          onClick={state.callFunction}
          message="Would you like to delete bank payment?"
          closeModal={() =>
            setState((prevState) => ({
              ...prevState,
              showConfirmBox: false,
            }))
          }
        ></ConfirmBox>
      )}
      <div className="modal-wrapper">
        <div className="bankdetail-modal-content" ref={ref}>
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={closeBankDetailsModal}
            >
              <span aria-hidden="true">×</span>
            </button>
            <h4 className="modal-title" id="myModalLabel">
              Bank Payment
            </h4>
          </div>
          <div className="modal-body" style={{ display: "block" }}>
            <div className="table-responsive">
              <table className="table table-striped jambo_table bulk_action">
                <thead>
                  <tr className="headings">
                    <th className="column-title">Amount</th>
                    <th className="column-title">Date</th>
                    <th className="column-title">Account</th>
                    <th className="column-title">UTR/Narration</th>
                    <th className="column-title">Transaction ID</th>
                    <th className="column-title">Added By</th>
                    <th className="column-title">Added Date</th>
                    <th className="column-title">Type</th>
                  </tr>
                </thead>
                <tbody>
                  {[...BankSummary].map((payment, idx) => {
                    const paymentType = paymentLabels[payment.bank_payment_id];
                    const added_date = convertToUTCFormat(
                      new Date(payment.added_date),
                      "dd/MM/yyyy"
                    );
                    const create_date = convertToUTCFormat(
                      new Date(payment.create_date),
                      "dd/MM/yyyy"
                    );
                    return (
                      <tr className="even pointer" key={idx}>
                        <td>{formatAmount(payment.bank_payment_amount)}</td>
                        <td>{added_date}</td>
                        <td>{payment.receiving_bank}</td>
                        <td>
                          <div
                            title={payment.utr_narration}
                            style={{
                              maxWidth: "200px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {payment.utr_narration}
                          </div>
                        </td>
                        <td>
                          <div
                            title={payment.transaction_id || ""}
                            style={{
                              maxWidth: "200px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {payment.transaction_id || ""}
                          </div>
                        </td>
                        <td>{payment.user_name}</td>
                        <td>{create_date}</td>
                        <td>
                          {paymentType}
                          <button
                            className="btn dlt-blnc mrg-R5"
                            style={{ display: isBtnDis }}
                            ref={ref}
                            onClick={() =>
                              openConfirmBox(() =>
                                deleteBankPayment(
                                  payment.bank_payment_amount,
                                  payment.bank_payment_id,
                                  current_balance
                                )
                              )
                            }
                          >
                            <i
                              className="fa fa-trash-o"
                              style={{ fontSize: "16px" }}
                            ></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              onClick={closeBankDetailsModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default BankPaymentDetailsModal;
